import { Routes } from '@angular/router';
import { authGuard, roleGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'courses',
    loadComponent: () => import('./features/courses/courses-list/courses-list.component').then(m => m.CoursesListComponent),
  },
  {
    path: 'courses/:id',
    loadComponent: () => import('./features/courses/course-detail/course-detail.component').then(m => m.CourseDetailComponent),
  },
  {
    path: 'sessions',
    loadComponent: () => import('./features/sessions/sessions.component').then(m => m.SessionsComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./features/login/prod-login/prod-login.component').then(m => m.ProdLoginComponent),
  },
  {
    path: 'register',
    loadComponent: () => import('./features/login/prod-register/prod-register.component').then(m => m.ProdRegisterComponent),
  },
  {
    path: 'terms',
    loadComponent: () => import('./features/legal/terms-of-service/terms-of-service.component').then(m => m.TermsOfServiceComponent),
  },
  {
    path: 'privacy',
    loadComponent: () => import('./features/legal/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
  },
  {
    path: 'student',
    loadComponent: () => import('./features/student/student-layout/student-layout.component').then(m => m.StudentLayoutComponent),
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/student/student-dashboard/student-dashboard.component').then(m => m.StudentDashboardComponent),
      },
      {
        path: 'progress',
        loadComponent: () => import('./features/student/student-progress/student-progress.component').then(m => m.StudentProgressComponent),
      },
      {
        path: 'certificates',
        loadComponent: () => import('./features/student/certificates/certificates.component').then(m => m.CertificatesComponent),
      },
      {
        path: 'sessions/:id/join',
        loadComponent: () => import('./features/student/join-session/join-session.component').then(m => m.JoinSessionComponent),
      },
      {
        path: 'notifications',
        loadComponent: () => import('./features/student/notifications/notifications.component').then(m => m.StudentNotificationsComponent),
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/student/profile/profile.component').then(m => m.StudentProfileComponent),
      },
      {
        path: 'sessions',
        loadComponent: () => import('./features/student/demo-sessions/demo-sessions.component').then(m => m.StudentDemoSessionsComponent),
      },
      {
        path: 'demo-sessions',
        redirectTo: 'sessions',
        pathMatch: 'full',
      },
      {
        path: 'batches',
        loadComponent: () => import('./features/student/student-batches/student-batches.component').then(m => m.StudentBatchesComponent),
      },
    ],
  },
  {
    path: 'admin',
    loadComponent: () => import('./features/admin/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    canActivate: [authGuard, roleGuard('ADMIN')],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/admin/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent),
      },
      {
        path: 'courses',
        loadComponent: () => import('./features/admin/course-management/course-management.component').then(m => m.CourseManagementComponent),
      },
      {
        path: 'batches',
        loadComponent: () => import('./features/admin/batch-management/batch-management.component').then(m => m.BatchManagementComponent),
      },
      {
        path: 'sessions',
        loadComponent: () => import('./features/admin/session-management/session-management.component').then(m => m.SessionManagementComponent),
      },
      {
        path: 'enrollments',
        loadComponent: () => import('./features/admin/enrollment-management/enrollment-management.component').then(m => m.EnrollmentManagementComponent),
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/student/profile/profile.component').then(m => m.StudentProfileComponent),
      },
    ],
  },
  {
    path: 'super-admin',
    loadComponent: () => import('./features/super-admin/super-admin-layout/super-admin-layout.component').then(m => m.SuperAdminLayoutComponent),
    canActivate: [authGuard, roleGuard('SUPER_ADMIN')],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/super-admin/dashboard/super-admin-dashboard.component').then(m => m.SuperAdminDashboardComponent),
      },
      {
        path: 'approval-queue',
        loadComponent: () => import('./features/super-admin/approval-queue/approval-queue.component').then(m => m.ApprovalQueueComponent),
      },
      {
        path: 'teachers',
        loadComponent: () => import('./features/super-admin/user-list/user-list.component').then(m => m.UserListComponent),
        data: {
          role: 'ROLE_ADMIN',
          title: 'All Teachers / Instructors',
          emptyIcon: 'fa-users',
          searchPlaceholder: 'Search by name, email or username...',
        },
      },
      {
        path: 'students',
        loadComponent: () => import('./features/super-admin/user-list/user-list.component').then(m => m.UserListComponent),
        data: {
          role: 'ROLE_STUDENT',
          title: 'All Students',
          emptyIcon: 'fa-user-graduate',
          searchPlaceholder: 'Search by name, email or username...',
        },
      },
      {
        path: 'courses',
        loadComponent: () => import('./features/super-admin/all-courses/all-courses.component').then(m => m.AllCoursesComponent),
      },
      {
        path: 'categories',
        loadComponent: () => import('./features/super-admin/course-categories/course-categories.component').then(m => m.CourseCategoriesComponent),
      },
      {
        path: 'analytics',
        loadComponent: () => import('./features/super-admin/analytics/analytics-dashboard.component').then(m => m.AnalyticsDashboardComponent),
      },
      {
        path: 'enrollment-requests',
        loadComponent: () => import('./features/super-admin/enrollment-requests/enrollment-requests.component').then(m => m.EnrollmentRequestsComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
